import { render, staticRenderFns } from "./QuestionBoxEditDialog.vue?vue&type=template&id=9b4aa372&scoped=true&"
import script from "./QuestionBoxEditDialog.vue?vue&type=script&lang=ts&"
export * from "./QuestionBoxEditDialog.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionBoxEditDialog.vue?vue&type=style&index=0&id=9b4aa372&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4aa372",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VTextField})
